// src/pages/VenuePage.js
import React from 'react';
import Navbar from '../components/Navbar';
import { WEDDING_CONFIG } from '../config';
import Footer from '../components/Footer';

const VenuePage = () => {

  return (
    <div style={styles.page}>
      <Navbar />
      
      {/* Fixed Background Image */}
      <div style={styles.backgroundImage}></div>
      
      {/* Hero Section */}
      <section style={styles.hero}>
        <h1 style={styles.heroTitle}>Venue</h1>
        <p style={styles.heroSubtitle}>
          Everything you need to know about our wedding day
        </p>
      </section>

      {/* Venue Information */}
      <section style={styles.section}>
        <div style={styles.container}>
          <div style={styles.glassCard}>
            <div style={styles.venueCard}>
              <div style={styles.venueInfo}>
                <h2 style={styles.venueTitle}>{WEDDING_CONFIG.venue.name}</h2>
                <div style={styles.venueDetail}>
                  <span style={styles.icon}>📍</span>
                  <p>{WEDDING_CONFIG.venue.address}</p>
                </div>
                <div style={styles.venueDetail}>
                  <span style={styles.icon}>📅</span>
                  <p>{new Date(WEDDING_CONFIG.weddingDate).toLocaleDateString('en-US', {
                    weekday: 'long',
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}</p>
                </div>
                
                <div style={styles.buttonGroup}>
                  <a 
                    href={`https://www.google.com/maps/search/?api=1&query=${WEDDING_CONFIG.venue.coordinates.lat},${WEDDING_CONFIG.venue.coordinates.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.mapButton}
                  >
                    🗺️ Open in Google Maps
                  </a>
                </div>

                {/* Divider */}
                <div style={styles.divider}></div>

                {/* Map Container */}
                <div style={styles.mapContainer}>
                  <iframe
                    title="Wedding Venue Map"
                    width="100%"
                    height="400"
                    style={styles.map}
                    src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d0!2d124.424764!3d12.5228652!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDMxJzIyLjMiTiAxMjTCsDI1JzI5LjIiRQ!5e0!3m2!1sen!2sph!4v1234567890123!5m2!1sen!2sph`}
                    allowFullScreen=""
                    loading="lazy"
                  ></iframe>
                </div>

                {/* Spacer under map */}
                <div style={styles.spacer}></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* ADD FOOTER HERE */}
      <Footer />
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  
  // Background Image - Only visible in glass sections (hidden behind hero gradient)
  backgroundImage: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${WEDDING_CONFIG.images.venue})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    zIndex: -1,
  },
  
  hero: {
    height: '100vh',
    background: `linear-gradient(135deg, ${WEDDING_CONFIG.colors.primary}, ${WEDDING_CONFIG.colors.secondary})`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center',
    marginTop: '60px',
    padding: '2rem',
  },
  heroTitle: {
    fontSize: '4rem',
    fontFamily: "'Great Vibes', 'Playfair Display', serif",
    marginBottom: '1rem',
  },
  heroSubtitle: {
    fontSize: '1.3rem',
    fontWeight: '300',
  },
  section: {
    padding: '4rem 2rem',
    flex: '1',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  
  // Frosted Glass Card Effect
  glassCard: {
    background: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(0.5px)',
    WebkitBackdropFilter: 'blur(0.5px)',
    borderRadius: '30px',
    padding: '4rem',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 16px 64px rgba(0, 0, 0, 0.1)',
  },
  
  venueCard: {
    display: 'flex',
    justifyContent: 'center',
  },
  venueInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    maxWidth: '800px',
    width: '100%',
  },
  venueTitle: {
    fontSize: '2.5rem',
    color: '#eee',
    fontFamily: "'Great Vibes', 'Playfair Display', serif",
    marginBottom: '1rem',
  },
  venueDetail: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    fontSize: '1.1rem',
    color: '#eee',
  },
  icon: {
    fontSize: '1.5rem',
    minWidth: '30px',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginTop: '1rem',
  },
  mapButton: {
    padding: '1rem',
    background: WEDDING_CONFIG.colors.primary,
    color: 'white',
    textDecoration: 'none',
    borderRadius: '10px',
    textAlign: 'center',
    fontWeight: '600',
    transition: 'transform 0.3s',
  },
  
  // Divider between button and map
  divider: {
    height: '1px',
    background: 'linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent)',
    margin: '2rem 0',
  },
  
  mapContainer: {
    borderRadius: '15px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    width: '100%',
  },
  map: {
    border: 'none',
    borderRadius: '15px',
  },
  
  // Spacer under map
  spacer: {
    height: '2rem',
  },
};

export default VenuePage;